// Mock data for iBizztax clone - all data is MOCKED for frontend preview

export const currentUser = {
  loginId: "SMSSB",
  companyName: "SMS Management Services Sdn Bhd",
  shortName: "SMSSB",
  credits: 130,
  used: 126,
  balance: 4,
};

// Client per Records bar chart
export const clientPerRecords = [
  { name: "C", value: 54 },
  { name: "B/BE", value: 3 },
  { name: "P", value: 6 },
  { name: "E", value: 1 },
];

// YA (Year of Assessment) per Form C - pie chart
export const yaFormC = [
  { name: "2018", value: 3.54 },
  { name: "2019", value: 3.54 },
  { name: "2020", value: 4.42 },
  { name: "2021", value: 4.42 },
  { name: "2022", value: 4.42 },
  { name: "2023", value: 14.16 },
  { name: "2024", value: 30.97 },
  { name: "2025", value: 33.63 },
  { name: "2026", value: 0.88 },
];

export const yaFormBBE = [{ name: "2022", value: 100 }];

export const yaFormP = [
  { name: "2022", value: 44.44 },
  { name: "2023", value: 33.33 },
  { name: "2024", value: 11.11 },
  { name: "2025", value: 11.11 },
];

export const yaFormE = [{ name: "2022", value: 100 }];

export const yaOwnership = [
  { name: "Local", value: 78.5 },
  { name: "Foreign", value: 21.5 },
];

// Companies / Clients (Data Entry list) - empty by default
export const companies = [];


// Detailed company profile
export const companyProfile = {
  name: "Alpha Trading Sdn Bhd",
  regNo: "201801001234",
  oldRegNo: "1234567-A",
  incomeTaxNo: "C 25101234567",
  employerNo: "E 1234567890",
  businessNature: "Wholesale trading of electronic goods",
  incorporationDate: "2018-01-15",
  financialYearEnd: "31 December",
  address: "Level 12, Menara ABC, Jalan Ampang, 50450 Kuala Lumpur",
  email: "admin@alphatrading.com.my",
  phone: "+603-2161 8888",
  taxAgent: "SMS Management Services Sdn Bhd",
  paidUpCapital: "RM 1,000,000",
};

// Tax computation (Form C) - MOCKED
export const taxComputation = {
  ya: "2024",
  netProfitBeforeTax: 850000,
  addBacks: [
    { label: "Depreciation", amount: 120000 },
    { label: "Provision for doubtful debts", amount: 25000 },
    { label: "Entertainment (50% non-deductible)", amount: 18000 },
    { label: "Penalties & fines", amount: 5000 },
  ],
  lessItems: [
    { label: "Capital allowance", amount: 145000 },
    { label: "Approved donations", amount: 30000 },
    { label: "Dividend income (exempt)", amount: 40000 },
  ],
  taxRate: 24,
};

// e-Tax filing statuses
export const eFilings = [
  { id: 1, company: "Alpha Trading Sdn Bhd", form: "C", ya: "2024", ackNo: "ACK-C-2024-000123", submittedDate: "2024-07-20", status: "Submitted", taxPayable: 129600 },
  { id: 2, company: "Beta Engineering Sdn Bhd", form: "C", ya: "2024", ackNo: "-", submittedDate: "-", status: "Draft", taxPayable: 0 },
  { id: 3, company: "Cahaya Holdings Sdn Bhd", form: "C", ya: "2025", ackNo: "-", submittedDate: "-", status: "Draft", taxPayable: 0 },
  { id: 4, company: "Delta Logistics Sdn Bhd", form: "C", ya: "2024", ackNo: "ACK-C-2024-000098", submittedDate: "2024-06-30", status: "Submitted", taxPayable: 52800 },
];

// Reports summary
export const reportsSummary = {
  totalClients: 64,
  filedThisYear: 38,
  pendingFilings: 21,
  draftFilings: 5,
  totalTaxPayable: 2456000,
  totalTaxRefund: 184000,
};

export const filingTrend = [
  { month: "Jan", filed: 4, pending: 2 },
  { month: "Feb", filed: 6, pending: 3 },
  { month: "Mar", filed: 5, pending: 4 },
  { month: "Apr", filed: 8, pending: 3 },
  { month: "May", filed: 7, pending: 5 },
  { month: "Jun", filed: 9, pending: 2 },
  { month: "Jul", filed: 12, pending: 6 },
];

export const PIE_COLORS = ["#2f7ed8", "#0d233a", "#8bbc21", "#910000", "#1aadce", "#492970", "#f28f43", "#77a1e5", "#c42525"];
